const commonColors = require("../common/consts/colors");
module.exports = {
  mode: "jit",
  theme: {
    extend: {
      fontFamily: {
        sans: ["Montserrat"],
        "sans-bold": ["Montserrat-Bold"],
        serif: ["Sahitya"],
        "serif-bold": ["Sahitya-Bold"],
        inter: ["Inter"],
        "inter-medium": ["Inter-Medium"],
        "inter-semibold": ["Inter-SemiBold"],
        "inter-bold": ["Inter-Bold"],
        mono: ["Azeret Mono"],
      },
      colors: {
        ...Object.keys(commonColors.lightColors).reduce(
          (acc, colorName) => {
            acc[colorName] = `var(--color-${colorName})`;
            return acc;
          },
          { ...commonColors.lightColors }, // start with light colors to appease typescript
        ),
      },
      boxShadow: {
        1: "0 4px 12px 0 rgba(0, 0, 0, 0.12)",
        2: "0 10px 30px -8px rgba(0, 0, 0, 0.2)",
        3: "0 16px 40px -15px rgba(0, 0, 0, 0.3)",
        surface: "0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)",
      },
      keyframes: {
        slideDownAndFade: {
          from: { opacity: "0", transform: "translateY(-2px)" },
          to: { opacity: "1", transform: "translateY(0)" },
        },
        slideLeftAndFade: {
          from: { opacity: "0", transform: "translateX(2px)" },
          to: { opacity: "1", transform: "translateX(0)" },
        },
        slideUpAndFade: {
          from: { opacity: "0", transform: "translateY(2px)" },
          to: { opacity: "1", transform: "translateY(0)" },
        },
        slideRightAndFade: {
          from: { opacity: "0", transform: "translateX(-2px)" },
          to: { opacity: "1", transform: "translateX(0)" },
        },
      },
      animation: {
        slideDownAndFade: "slideDownAndFade 400ms cubic-bezier(0.16, 1, 0.3, 1)",
        slideLeftAndFade: "slideLeftAndFade 400ms cubic-bezier(0.16, 1, 0.3, 1)",
        slideUpAndFade: "slideUpAndFade 400ms cubic-bezier(0.16, 1, 0.3, 1)",
        slideRightAndFade: "slideRightAndFade 400ms cubic-bezier(0.16, 1, 0.3, 1)",
      },
      fontSize: {
        "2xs": "0.625rem",
        "3xs": "0.575rem",
      },
    },
    screens: {
      xs: "336px",
      sm: "428px",
      md: "768px",
      lg: "1080px",
      xl: "1440px",
    },
  },
  plugins: [],
  purge: ["./src/**/*.{js,jsx,ts,tsx}", "./pages/**/*.{js,ts,jsx,tsx}", "../common/consts/colors.js"],
};
